const toggleNav = () => {
  const button = document.querySelector(".header .button");
  const mainNav = document.querySelector(".header .text");

  if (button && mainNav) {
    button.addEventListener("click", () => {
      mainNav.classList.toggle("is-open");
    });
  }
};

const toggleListItems = () => {
  const listItems = document.querySelectorAll(".header .cmp-container .cmp-text li");

  listItems.forEach((li) => {
    li.addEventListener("click", (e) => {
      if (e.target.closest(".no-toggle")) {
        e.preventDefault();
        return;
      }

      const parentUl = li.parentElement;
      const currentlyOpen = parentUl.querySelector("li.open");

      if (currentlyOpen === li) {
        li.classList.toggle("open");
      } else {
        if (currentlyOpen) {
          currentlyOpen.classList.remove("open");
        }
        li.classList.add("open");
      }

      e.stopPropagation();
    });
  });
};

const onDocumentReady = () => {
  const mainNav = document.getElementsByClassName("header");

  if (mainNav.length > 0) {
    toggleNav();
  }

  toggleListItems();
};

if (document.readyState !== "loading") {
  onDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", onDocumentReady);
}